import React from 'react';
import classNames from 'classnames';

const SurveyResult = (props) => {
  const setColor = (index) => {
    const colors = props.resultMeterColors;
    return colors[index % colors.length];
  };

  const ListItems = ({ result }) => {
    return result.map((item, index) => {
      return (
        <div className="result-item" key={index}>
          <div className="result-label">
            {item.Answer} ({item.Percent}%)
          </div>
          <div className="result-meter">
            <span
              style={{
                width: item.Percent + '%',
                backgroundColor: setColor(index),
              }}
            ></span>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="c-survey-result" data-cy="survey-result">
      {props.IsActive && (
        <button
          className="c-survey-result__btn"
          data-cy="c-survey-result__close-btn"
          onClick={props.toggle}
        >
          <span className="show-for-sr">{props.Translations.close}</span>
        </button>
      )}

      <div
        className={classNames({
          'c-survey-result__text': true,
          'c-survey-result--closed': !props.IsActive,
        })}
      >
        {props.ResultText}
        {props.ShowAnswerCount && (
          <span> ({props.result.Translations.votes})</span>
        )}
      </div>

      <ListItems result={props.result.Results} />
    </div>
  );
};

export default SurveyResult;
